<template>
  <div class="EditUser lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="EditUser-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="EditUser-main lxn-pos-rel">
      <div class="EditUser-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.EditUser_title1}}
          </template>
          <template v-slot:body>
            <div class="EditUser-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.EditUser_text1}}
            </div>
            <div class="lxn-w100 lxn-title lxn-text-en lxn-text-center">
              {{user.mobile}}
            </div>
            <div class="EditUser-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              UUID
            </div>
            <div class="lxn-w100 lxn-title lxn-text-en lxn-text-center">
              {{user.uuid}}
            </div>
            <div class="EditUser-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.EditUser_text2}}
            </div>
            <div v-if="user.isOwner" class="lxn-w100 lxn-title lxn-text-en lxn-text-center" :class="$store.getters.language.font">
              {{$store.getters.language.texts.EditUser_ownerText}}
            </div>
            <div v-else class="lxn-w100 lxn-title lxn-text lxn-text-center" :class="$store.getters.language.font">
              {{$store.getters.language.texts.EditUser_normalText}}
            </div>
            <div class="EditUser-wrapper-fieldTitle lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.EditUser_text3}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="inputFieldState='active'" @blur="inputFieldState=''" :inputState="inputFieldState" v-model="userName" bgColor="#FFFFFF" inputType="text" />
            </div>
          </template>
        </TitleBox>
      </div>
      <div v-if="!user.isOwner" class="EditUser-button lxn-margin-auto lxn-w100">
        <CustomButton :disabled="isHubOffline" @click="deleteUser" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.EditUser_button1}}
        </CustomButton>
      </div>
      <div class="EditUser-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.EditUser_button2}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'


export default {
  name: 'EditUser',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
  },
  data: function () {
    return {
      hub: this.$store.getters.getHubByUUID(this.$route.params.hubUUID),
      userName: '',
      inputFieldState: '',
    }
  },
  mounted: function () {
    this.userName = this.user.name;
  },
  computed: {
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    user: function () {
      return this.hub.users[this.$route.params.userIndex];
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.hub.color];
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    saveChanges: function () {
      this.inputFieldState = '';
      if(this.userName == ''){
        this.inputFieldState = 'error';
        alert(this.$store.getters.language.texts.EditUser_alert);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('setUserName', {hubIndex: this.hub.index, userIndex: this.$route.params.userIndex, name: this.userName});
        this.$store.commit('saveState');
        this.$router.push('/hubUserSettings/' + this.hub.uuid);
        this.$store.commit('setAppBusy', false);
      }
    },
    deleteUser: function () {
      this.$router.push('/deleteUser/' + this.hub.uuid + '/' +  this.$route.params.userIndex);
    },
  }
}
</script>

<style>
  .EditUser-topCurve-wrapper {
    height: 200px;
  }
  .EditUser-main {
    z-index: 2;
  }
  .EditUser-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .EditUser-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .EditUser-wrapper-outputState {
    height: 50px;
    color: #52626C;
    line-height: 50px;
  }
  .EditUser-wrapper-outputState-right {
    width: calc(100% - 84px);
  }
  .EditUser-wrapper-outputState-left {
    width: 70px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .EditUser-wrapper-fieldTitle:first-child {
    height: 25px;
    line-height: 25px;
    padding-top: 0;
  }
  .EditUser-wrapper-fieldTitle {
    height: 35px;
    padding-top: 10px;
    line-height: 25px;
    color: #52626C;
  }
</style>
